import {
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/pro-regular-svg-icons';
import MuiAlert, { AlertProps as MuiAlertProps } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import { Icon } from '../components/Icon';

export interface AlertProps extends MuiAlertProps {
  title?: string;
  severity?: 'success' | 'info' | 'warning' | 'error';
}

export const Alert: React.FC<AlertProps> = ({
  children,
  sx,
  title,
  color,
  severity = 'info',
  ...otherProps
}) => {
  const iconStyles = { mt: '2px' };

  const finalColor = color || severity;

  const styles = () => {
    return {
      bgcolor: `${finalColor}.backgroundSoft`,
      color: `${finalColor}.text`,
      '& .MuiAlert-icon': {
        color: `${finalColor}.text`,
      },
      '& .MuiAlert-action': {
        color: `${finalColor}.text`,
      },
    };
  };

  return (
    <MuiAlert
      sx={[styles, ...(Array.isArray(sx) ? sx : [sx])]}
      color={color}
      severity={severity}
      iconMapping={{
        success: <Icon sx={iconStyles} icon={faCheckCircle} />,
        info: <Icon sx={iconStyles} icon={faInfoCircle} />,
        warning: <Icon sx={iconStyles} icon={faExclamationTriangle} />,
        error: <Icon sx={iconStyles} icon={faExclamationCircle} />,
      }}
      {...otherProps}
    >
      {title && <AlertTitle sx={{ fontWeight: 400 }}>{title}</AlertTitle>}
      {children}
    </MuiAlert>
  );
};
